// extracted by mini-css-extract-plugin
export default {"errorPage":"errorPage_errorPage__RGStB","errorPage__logo":"errorPage_errorPage__logo__E58KL"};